import Lesson from '@/models/Lesson';
import { ROUTES } from '../routes';
import { LessonFields } from '@/components/_deprecated/courses/box/lesson/LessonBoxForm';
import { buildChangedObject } from '../buildChangedObject';
import {
  adapterLessonFieldsToLessonDTO,
  tratateLinks,
  adapterLessonToLessonDTO,
} from './adapter';

export const getSelectedLesson = (
  lessons: Lesson[],
  lessonOrderParam?: string,
) => {
  if (!lessonOrderParam) return lessons.at(0);
  const lessonOrder = Number(lessonOrderParam);
  const lesson = lessons.find(lesson => lesson.order === lessonOrder);
  return lesson;
};

export const getBoxPathname = (slug?: string, lessonId?: string) => {
  if (!slug) return '';
  if (lessonId) {
    return ROUTES.COURSES.BOX.LESSON(slug, parseInt(lessonId));
  }
  return ROUTES.COURSES.BOX.INFO(slug);
};

export const getLessonChanges = async (
  oldLesson: Lesson,
  newLesson: Partial<LessonFields>,
) => {
  let modifiedLesson = adapterLessonFieldsToLessonDTO(newLesson);
  modifiedLesson = tratateLinks(modifiedLesson);
  const originalLesson = adapterLessonToLessonDTO(oldLesson);
  const lessonsChanges = buildChangedObject(originalLesson, modifiedLesson);
  return lessonsChanges;
};

export const getPreviousLesson = (lessons: Lesson[], lessonId: number) => {
  for (let i = 0; i < lessons.length; i++) {
    if (lessons[i].id === lessonId) return lessons[i - 1];
  }
  return undefined;
};

export const getNextLesson = (lessons: Lesson[], lessonId: number) => {
  for (let i = 0; i < lessons.length; i++) {
    if (lessons[i].id === lessonId) return lessons[i + 1];
  }
  return undefined;
};
